import { ACTION_TYPE, fetchWithoutBody, fetchJson } from '../../store/actionCreatorsHelpers';

interface Payload {
    appId?: string;
    name?: string;
    sideloadedAppDefinition?: File;
    appDefinitionFile?: File;
}

export function reloadAppDefinition({ appDefinitionFile }: Payload) {
    return {
        type: ACTION_TYPE.RELOAD_APP_DEFINITION,
        appDefinitionFile,
    };
}

export function reuploadSideloadedApp({ appId, sideloadedAppDefinition }: Payload) {
    return {
        type: ACTION_TYPE.REUPLOAD_SIDELOADED_APP,
        payload: fetchJson(`api/sideload/${appId}`, {
            method: 'PUT',
            body: sideloadedAppDefinition,
        }),
    };
}

export function closeSideloadedAppConfigurationModal() {
    return {
        type: ACTION_TYPE.CLOSE_SIDELOADED_APP_CONFIGURATION_MODAL,
    };
}

export function openSideloadedAppConfigurationModal({ appId, name }: Payload) {
    return {
        type: ACTION_TYPE.OPEN_SIDELOADED_APP_CONFIGURATION_MODAL,
        appId,
        name,
    };
}

export function removeSideloadedApp({ appId }: Payload) {
    return {
        type: ACTION_TYPE.REMOVE_SIDELOADED_APP,
        payload: fetchWithoutBody(`api/sideload/${appId}`, {
            method: 'DELETE',
        }),
    };
}

export function showConfirmationModal() {
    return {
        type: ACTION_TYPE.SHOW_REMOVE_SIDELOADED_APP_CONFIRMATION_MODAL,
    };
}
